module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [(_vm.ysf) ? _c('div', {
    attrs: {
      "id": "HelloWorld"
    }
  }, [_c('div', {
    staticClass: "pages"
  }, [_c('div', {
    staticClass: "btn-box"
  }, [_c('UPButton', {
    attrs: {
      "id": "btnLogin",
      "scope": _vm.scope
    },
    on: {
      "click": _vm.btnClick
    }
  }, [_vm._v("\n          一键登录\n        ")])], 1), _vm._v(" "), (_vm.btLoading) ? _c('div', {
    staticClass: "loading",
    attrs: {
      "id": "circle"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('mu-appbar', [_c('span', {
    staticClass: "topT"
  }, [_vm._v("会员登录")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bigpage"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    staticStyle: {
      "font-size": "120%"
    },
    attrs: {
      "value": "tab1",
      "title": "普通登录"
    }
  }), _vm._v(" "), _c('mu-tab', {
    staticStyle: {
      "font-size": "120%"
    },
    attrs: {
      "value": "tab2",
      "title": "快捷登录"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'tab1') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "2vh",
      "lign-height": "1.5"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "卡号/手机号/邮箱",
      "type": "text",
      "icon": "smartphone",
      "fullWidth": ""
    },
    model: {
      value: (_vm.UserName),
      callback: function($$v) {
        _vm.UserName = $$v
      },
      expression: "UserName"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入密码",
      "type": "password",
      "icon": "lock",
      "fullWidth": ""
    },
    model: {
      value: (_vm.UserPass),
      callback: function($$v) {
        _vm.UserPass = $$v
      },
      expression: "UserPass"
    }
  }), _vm._v(" "), (_vm.FJMPD) ? _c('nobr', {
    attrs: {
      "id": "FJMPart"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%"
    },
    attrs: {
      "hintText": "请输入附加码",
      "type": "text",
      "icon": "location_city"
    },
    model: {
      value: (_vm.FJM1),
      callback: function($$v) {
        _vm.FJM1 = $$v
      },
      expression: "FJM1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "27%",
      "margin-left": "2%",
      "margin-top": "-0.1rem"
    },
    attrs: {
      "src": _vm.TPFJM,
      "align": "right"
    },
    on: {
      "click": this.getValidateCode
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.2rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "登 录",
      "primary": ""
    },
    on: {
      "click": _vm.Login1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "2vh"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入手机号",
      "type": "text",
      "icon": "smartphone",
      "fullWidth": ""
    },
    model: {
      value: (_vm.UserPhone),
      callback: function($$v) {
        _vm.UserPhone = $$v
      },
      expression: "UserPhone"
    }
  }), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%",
      "display": "none"
    },
    attrs: {
      "hintText": "请输入附加码",
      "type": "text",
      "icon": "vpn_key"
    },
    model: {
      value: (_vm.FJM1),
      callback: function($$v) {
        _vm.FJM1 = $$v
      },
      expression: "FJM1"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "30%",
      "float": "right",
      "margin-top": "-0.1rem",
      "display": "none"
    },
    attrs: {
      "src": _vm.TPFJM
    },
    on: {
      "click": this.getValidateCode
    }
  })], 1), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "69%",
      "z-index": "1"
    },
    attrs: {
      "hintText": "请输入手机验证码",
      "type": "text",
      "icon": "verified_user"
    },
    model: {
      value: (_vm.YZM),
      callback: function($$v) {
        _vm.YZM = $$v
      },
      expression: "YZM"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == false),
      expression: "haveYZM == false"
    }]
  }, [_c('input', {
    staticStyle: {
      "font-size": "0.3rem",
      "float": "right",
      "background-color": "#27ba69",
      "height": "0.7rem",
      "border": "none",
      "width": "30%",
      "color": "white"
    },
    attrs: {
      "type": "button",
      "id": "j-popup",
      "value": "获取"
    },
    on: {
      "click": _vm.NetEaseDunClick
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveYZM == true),
      expression: "haveYZM == true"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.WaitTime),
      expression: "WaitTime"
    }],
    staticStyle: {
      "font-size": "0.32rem",
      "float": "right",
      "background-color": "#eeeeee",
      "height": "0.7rem",
      "border": "none",
      "width": "30%",
      "color": "#999"
    },
    attrs: {
      "type": "button"
    },
    domProps: {
      "value": (_vm.WaitTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.WaitTime = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.2rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "登录/注册",
      "primary": ""
    },
    on: {
      "click": _vm.QuickLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #27ba69",
      "padding": "0.15rem",
      "border-radius": "3px"
    }
  }, [_c('router-link', {
    staticStyle: {
      "font-size": "0.3rem"
    },
    attrs: {
      "slot": "left",
      "to": "/user/OtherUser"
    },
    slot: "left"
  }, [_vm._v("\n          非会员/协议预订订单查询\n        ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.46rem"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "Grey",
    attrs: {
      "to": "/user/Register"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "0.3rem",
      "color": "#999"
    }
  }, [_vm._v("\n          注册账号\n        ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "Grey",
    attrs: {
      "to": "/user/ForgotPass"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "0.3rem",
      "color": "#999"
    }
  }, [_vm._v("\n          忘记密码\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "unionLogin"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    attrs: {
      "href": _vm.urls.QQ
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/user/unionLogin/login_qq.png")
    }
  })])])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "captcha"
    }
  })], 1), _vm._v(" "), (_vm.showVerifyCode) ? _c('div', {
    staticStyle: {
      "width": "100vw",
      "height": "100vh",
      "background-color": "rgba(0,0,0,0.5)",
      "position": "fixed",
      "top": "0",
      "left": "0",
      "z-index": "9"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0.5rem",
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)",
      "background-color": "white",
      "border-radius": "4px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.22rem",
      "position": "absolute",
      "top": "0.2rem",
      "right": "0.2rem"
    },
    attrs: {
      "src": require("../../../../static/close.png"),
      "alt": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "font-size": "0.35rem",
      "text-align": "center",
      "font-weight": "bold",
      "margin-bottom": "0.4rem",
      "color": "black"
    }
  }, [_vm._v("请输入图形验证码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "border": "1px solid #aaa",
      "border-radius": "4px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    staticStyle: {
      "width": "3rem",
      "height": "0.64rem",
      "margin": "0",
      "outline": "0",
      "border": "0",
      "font-size": "0.32rem",
      "line-height": "0.64rem",
      "padding": "0 0 0 0.15rem"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.verify.VerifyType == '1') ? _c('img', {
    attrs: {
      "src": 'data:image/png;base64,' + _vm.verify.VerifyCode,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.getVerifyImgCode()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "font-size": "0.28rem",
      "line-height": "0.28rem",
      "text-align": "center",
      "margin-top": "0.4rem",
      "padding": "0.22rem 0",
      "background-color": "#ff944b",
      "border-radius": "0.6rem",
      "color": "white"
    },
    on: {
      "click": _vm.APPDownloadCount2
    }
  }, [_vm._v("确认")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', [_vm._v("合作网站账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-438b412e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NonVerified/Login.vue
// module id = 190
// module chunks = 17 18